import PerfectScrollbar from 'react-perfect-scrollbar';
import styled from 'styled-components';

export const TileSummaries = styled(PerfectScrollbar)`
  background-color: #ffffff;
`;

export const CategoryTitle = styled.div`
  padding: 0 14px;
  border-top: 2px solid #0000008a;
  border-bottom: 2px solid #0000008a;
  background-color: #d9d9d9;
`;
